
import {initWebComponent} from "@/helpers/web-component-helper";
import {
    getFeatureInfoByFeatureInfoKey
} from "@/helpers/plugin-helper";
import {Point} from "ol/geom";
import {WKT} from "ol/format";
import {Vector} from "ol/layer";
import {showPluginOnMap} from "@/helpers/ol/ol-plugin-helper";
import {getBySelector} from "@/helpers/element-helper.js";

export class LayerInfoInfoPluginCycloramaComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        const featureInfoKey = this.getAttribute('data-feature-info-key')
        const featureKey = this.getAttribute('data-feature-key')
        const mainTabIndex = this.getAttribute('data-main-tab-index')

        const featureInfo = getFeatureInfoByFeatureInfoKey(featureKey, featureInfoKey)

        window.cycloramaBookmarkPresentationID = window.mainTabs[mainTabIndex].BookmarkPresentationID

        const record = featureInfo.records[0]
        const coordinates = record.geometry.coordinates

        const attributeItem = record.attributes[0][0]

        const xy = coordinates[0] + ',' + coordinates[1]

        let viewerType = ''
        switch (parseInt(attributeItem.ActionAdvanced)) {
            case 1:
                viewerType = 'OBLIQUE'
                break;
            case 2:
                viewerType = 'MESHVIEWER'
                break;
            case 3:
                viewerType = 'POINTCLOUD'
                break;
            default:
                viewerType = 'PANORAMA'
                break;
        }

        let navbarVisible = '1'
        if(attributeItem.ActionAdvancedSecond) {
            navbarVisible = '0'
        }
        let is3DCursorVisible = '1'
        if(attributeItem.ActionAdvancedThird) {
            is3DCursorVisible = '0'
        }

        const url = window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID +
            '/cyclorama?xy=' + xy +
            '&viewertype=' + viewerType +
            '&navbarVisible=' + navbarVisible +
            '&is3DCursorVisible=' + is3DCursorVisible

        let innerHTML = ``

        if(attributeItem.Action === 1) {
            innerHTML += `
           <div class="card-body pl-2 pr-2">
                <div class="row">
                    <div class="col-5">Cyclorama</div>
                    <div class="col-7"><a target="_blank" href="${url}">Open link</a></div>
                </div>
            </div>
            `
        } else {
            innerHTML += `
            <div class="embed-responsive embed-responsive-4by3 h-100">
                <iframe 
                    class="embed-responsive-item" 
                    seamless=""
                     allowtransparency="true" 
                     allowfullscreen="" 
                    src="` + url + `">
                </iframe>
            </div>
            `
        }

        template.innerHTML = innerHTML

        initWebComponent(this, template)

        // showCyclo(161567.082, 383215.856, 119.21539217706193, -2.412532637075718, 110);
    }
}


export function showCyclo(coord_x, coord_y, pan, tilt, fov, visible) {
    const yval = 3 + (120 - fov) / 7;
    const xval = 2 + 5 * 3 / yval;

    if (coord_x > 0) {
        showPluginGeneric(coord_x, coord_y, pan, tilt, fov, xval, yval, 360 - pan, visible);
    }
}


function showPluginGeneric(coord_x, coord_y, pan, tilt, fov, xval, yval, rotate_angle, visible) {
    const origin = new Point([coord_x, coord_y]);
    const source = "POLYGON((" + coord_x + " " + coord_y + "," + (coord_x - 1) + " " + coord_y + "," + (coord_x - xval) + " " + (coord_y + yval) + "," + (coord_x + xval) + " " + (coord_y + yval) + "," + coord_x + " " + coord_y + "," + (coord_x + 1) + " " + coord_y + "))"

    showPluginOnMap(source, origin, rotate_angle, visible)
}
